module.exports = __webpack_public_path__ + "img/zoomed-NIST-withwords-2.0957bc72.png";